import * as React from "react"
const SvgThumbsUpShine = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M12.522 1.75a.75.75 0 0 1 .75.75v1.059a.75.75 0 0 1-1.5 0V2.5a.75.75 0 0 1 .75-.75M8.067 3.339a.75.75 0 0 1 1.06 0l.749.748a.75.75 0 1 1-1.06 1.061l-.75-.749a.75.75 0 0 1 0-1.06m8.91 0a.75.75 0 0 1 0 1.06l-.748.749a.75.75 0 1 1-1.06-1.06l.748-.75a.75.75 0 0 1 1.06 0m-6.484 5.063A2.525 2.525 0 0 1 13.86 7.31l.359.18a2.17 2.17 0 0 1 1.2 1.94v2.206h1.497a2.88 2.88 0 0 1 2.813 3.498l-.848 3.854a2.88 2.88 0 0 1-2.813 2.261h-9.8a1.815 1.815 0 0 1-1.815-1.815v-5.984c0-1.002.813-1.815 1.815-1.815h2.537zM8.5 13.137H6.268a.315.315 0 0 0-.315.314v5.984c0 .174.141.315.315.315H8.5zM10 19.75h6.068a1.38 1.38 0 0 0 1.348-1.083l.848-3.854a1.38 1.38 0 0 0-1.348-1.677H14.67a.75.75 0 0 1-.75-.75V9.432a.67.67 0 0 0-.37-.599l-.36-.18a1.025 1.025 0 0 0-1.366.443L10 12.59zM5.948 7.794a.75.75 0 0 1 .75-.75h1.06a.75.75 0 1 1 0 1.5h-1.06a.75.75 0 0 1-.75-.75m10.589 0a.75.75 0 0 1 .75-.75h1.059a.75.75 0 1 1 0 1.5h-1.06a.75.75 0 0 1-.75-.75"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgThumbsUpShine
